module.exports = __webpack_public_path__ + "fonts/LTCCaymanGoudyModern-Italic.7b2b33e791d667e96692d56f1daad2d2.eot";